import styled from "styled-components";

export default styled.div`
  border-top: 1px solid #eee;
  padding: 15px;
  display: flex;
  justify-content: flex-end;
`;
